export default {
  title: '素材庫',
  tabImage: '圖片',
  tabVideo: '影片',
  allGroups: '全部分組',
  addGroup: '添加分組',
  editGroup: '編輯分組',
  deleteGroup: '刪除分組',
  groupName: '分組名稱',
  groupNamePlaceholder: '請輸入分組名稱',
  confirmDeleteGroup: '確認刪除該分組嗎？刪除後分組下的素材將移至未分組。',
  upload: '上傳圖片',
  uploadVideo: '上傳影片',
  batchGroup: '批量分組',
  batchDelete: '批量刪除',
  searchName: '圖片名稱',
  searchNamePlaceholder: '請輸入名稱',
  selected: '已選',
  item: '項',
  cancelSelect: '取消選擇',
  preview: '預覽',
  copyLink: '複製連結',
  confirmDelete: '確認刪除選中的素材嗎？',
  confirmDeleteSingle: '確認刪除該素材嗎？',
  copySuccess: '連結已複製',
  moveSuccess: '移動成功',
  uploadSuccess: '上傳成功',
  uploadTitle: '上傳素材',
  dragTip: '點擊或拖曳檔案到此區域上傳',
  uploadLimit: '支援 JPG、PNG、GIF 格式，單張不超過 5MB',
  uploadVideoLimit: '支援 MP4、AVI 格式，單個不超過 500MB',
  editTitle: '編輯素材',
  materialName: '素材名稱',
  materialNamePlaceholder: '請輸入素材名稱',
  moveGroupTitle: '移動到分組',
  targetGroup: '目標分組',
  selectGroupPlaceholder: '請選擇分組',
  ungrouped: '未分組',
  emptyImage: '暫無圖片',
  emptyVideo: '暫無影片',
  uploadNow: '立即上傳',
  videoCover: '影片封面',
  uploadCover: '上傳封面',
  uploadFile: '上傳檔案',
  uploadFileRequired: '請選擇要上傳的檔案',
  videoCoverRequired: '請上傳影片封面',
  fileSizeExceed: '文件大小超過 {max}',
};
